/// <amd-module name="Repos/Views/CommitHub/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\commit-hub\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Git from "Repos/Common/Contracts/Git";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Retrieve git commits for a project matching the search criteria
     * 
     * @param searchCriteria - Search options
     * @param repositoryId - The name or ID of the repository.
     * @param project - Project ID or project name
     * @param skip - Number of commits to skip. The value cannot exceed 3,000,000.
     * @param top - Maximum number of commits to return. The value cannot exceed 50,000.
     * @param includeStatuses - True to include additional commit status information.
     */
    getCommitsBatch(searchCriteria: Git.GitQueryCommitsCriteria, repositoryId: string, project?: string, skip?: number, top?: number, includeStatuses?: boolean): Promise<Git.GitCommitRef[]>;
    /**
     * This API is used to find what pull requests are related to a given commit.  It can be used to either find the pull request that created a particular merge commit or it can be used to find all pull requests that have ever merged a particular commit.  The input is a list of queries which each contain a list of commits. For each commit that you search against, you will get back a dictionary of commit -\> pull requests.
     * 
     * @param queries - The list of queries to perform.
     * @param repositoryId - ID of the repository.
     * @param project - Project ID or project name
     */
    getPullRequestQuery(queries: Git.GitPullRequestQuery, repositoryId: string, project?: string): Promise<Git.GitPullRequestQuery>;
    /**
     * Get statuses associated with the Git commit.
     * 
     * @param commitId - ID of the Git commit.
     * @param repositoryId - ID of the repository.
     * @param project - Project ID or project name
     * @param top - Optional. The number of statuses to retrieve. Default is 1000.
     * @param skip - Optional. The number of statuses to ignore. Default is 0. For example, to retrieve results 101-150, set top to 50 and skip to 100.
     * @param latestOnly - The flag indicates whether to get only latest statuses grouped by \`Context.Name\` and \`Context.Genre\`.
     */
    getStatuses(commitId: string, repositoryId: string, project?: string, top?: number, skip?: number, latestOnly?: boolean): Promise<Git.GitStatus[]>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Retrieve git commits for a project matching the search criteria
     * 
     * @param searchCriteria - Search options
     * @param repositoryId - The name or ID of the repository.
     * @param project - Project ID or project name
     * @param skip - Number of commits to skip. The value cannot exceed 3,000,000.
     * @param top - Maximum number of commits to return. The value cannot exceed 50,000.
     * @param includeStatuses - True to include additional commit status information.
     */
    public async getCommitsBatch(
        searchCriteria: Git.GitQueryCommitsCriteria,
        repositoryId: string,
        project?: string,
        skip?: number,
        top?: number,
        includeStatuses?: boolean
        ): Promise<Git.GitCommitRef[]> {

        const queryValues: any = {
            '$skip': skip,
            '$top': top,
            includeStatuses: includeStatuses
        };

        return this.beginRequest<Git.GitCommitRef[]>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/CommitsBatch",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            queryParams: queryValues,
            body: searchCriteria
        });
    }

    /**
     * This API is used to find what pull requests are related to a given commit.  It can be used to either find the pull request that created a particular merge commit or it can be used to find all pull requests that have ever merged a particular commit.  The input is a list of queries which each contain a list of commits. For each commit that you search against, you will get back a dictionary of commit -\> pull requests.
     * 
     * @param queries - The list of queries to perform.
     * @param repositoryId - ID of the repository.
     * @param project - Project ID or project name
     */
    public async getPullRequestQuery(
        queries: Git.GitPullRequestQuery,
        repositoryId: string,
        project?: string
        ): Promise<Git.GitPullRequestQuery> {

        return this.beginRequest<Git.GitPullRequestQuery>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/PullRequestQuery",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            body: queries
        });
    }

    /**
     * Get statuses associated with the Git commit.
     * 
     * @param commitId - ID of the Git commit.
     * @param repositoryId - ID of the repository.
     * @param project - Project ID or project name
     * @param top - Optional. The number of statuses to retrieve. Default is 1000.
     * @param skip - Optional. The number of statuses to ignore. Default is 0. For example, to retrieve results 101-150, set top to 50 and skip to 100.
     * @param latestOnly - The flag indicates whether to get only latest statuses grouped by \`Context.Name\` and \`Context.Genre\`.
     */
    public async getStatuses(
        commitId: string,
        repositoryId: string,
        project?: string,
        top?: number,
        skip?: number,
        latestOnly?: boolean
        ): Promise<Git.GitStatus[]> {

        const queryValues: any = {
            top: top,
            skip: skip,
            latestOnly: latestOnly
        };

        return this.beginRequest<Git.GitStatus[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/commits/{commitId}/Statuses",
            routeValues: {
                project: project,
                commitId: commitId,
                repositoryId: repositoryId
            },
            queryParams: queryValues
        });
    }

}

export const GitClientName = "Repos.CommitDetail.Git.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
